/*
 * Copyright 2025 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-mobile/blob/master/LICENSE.md
 */
package org.mifos.mobile.feature.loan.application.component

/**
* Represents the specific categories of documents required for a loan application.
*/
enum class DocumentType {
    BANK_STATEMENT,
    PROPERTY_DOCUMENT,
    SIGNATURE,
}
